import React, { Component } from 'react';
import LanguageIcon from '@material-ui/icons/Language';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import Badge from '@material-ui/core/Badge';

//@ts-ignore
import {SharedIntlConsumer, SharedIntlProvider} from '../Intl/SharedIntlProvider';

export type LanguageButtonProps = InjectedIntlProps

export interface LanguageButtonState {
  anchorEl?: HTMLElement;
}

class LanguageButton extends Component<LanguageButtonProps, LanguageButtonState> {
  constructor(props: LanguageButtonProps) {
    super(props);
    this.state = { anchorEl: null };
  }

  handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  // change language (passed in as function) and close the button
  changeLangAndClose = (changeLang: Function, lang: string) => {
    changeLang(lang);
    this.handleClose();
  };

  render() {
    const { intl, ...props } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <SharedIntlConsumer>
        {(x: SharedIntlProvider) => {
          return (
            <React.Fragment>
              <IconButton
                color="inherit"
                onClick={this.handleMenu}
                {...props}
              >
                <Badge
                  badgeContent={intl.formatMessage({ id: 'language.badge'})}
                  color="secondary"
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                >
                  <LanguageIcon />
                </Badge>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={this.handleClose}
              >
                <MenuItem onClick={() => this.changeLangAndClose(x.changeLocale, 'en')}>English</MenuItem>
                <MenuItem onClick={() => this.changeLangAndClose(x.changeLocale, 'ja')}>日本語</MenuItem>
              </Menu>
            </React.Fragment>
          );
        }}
      </SharedIntlConsumer>
    );
  }
}

export default injectIntl(LanguageButton);
